import classNames from 'classnames';
import React from 'react';

import {Button, Dropdown, Icon, MenuListItem, Text} from '@albert-io/atomic';
import type {CurriculumArea, FilterOption} from './types';

interface Props {
  curriculumAreas: CurriculumArea[];
  selectedFilter: FilterOption;
  setSelectedFilter: (option: FilterOption) => void;
}

export function CurriculumAreaDropdown({
  curriculumAreas,
  selectedFilter,
  setSelectedFilter
}: Props) {
  'use memo';

  const options: FilterOption[] = ['All', ...curriculumAreas.map((ca) => ca.name)];

  return (
    <Dropdown
      className='min-w-max'
      contentClassName='p-x1!'
      position='bottom-start'
      trayProps={{
        modifiers: {
          flip: {enabled: false},
          preventOverflow: {
            boundariesElement: 'viewport'
          }
        }
      }}
      trigger={
        <Button color='secondary' variant='outlined'>
          <Text className='font-normal' size='m' color='secondary'>
            {selectedFilter}
          </Text>
          <Icon icon='caret-down' className='ml-x1' color='secondary' />
        </Button>
      }
      closeOnItemClicked
      positionFixed
    >
      {options.map((option) => (
        <MenuListItem
          key={option}
          as='li'
          className={classNames(
            'justify-start border-0! px-x1-half! py-x1! hover:background-info-subtle!',
            {
              'background-info-subtle!': selectedFilter === option
            }
          )}
          onClick={() => setSelectedFilter(option)}
          aria-selected={selectedFilter === option}
        >
          <Text
            className='flex w-full items-center justify-between'
            size='m'
            color={selectedFilter === option ? 'info' : 'primary'}
          >
            {option}
            {selectedFilter === option && <Icon icon='check' color='info' className='ml-x1' />}
          </Text>
        </MenuListItem>
      ))}
    </Dropdown>
  );
}
